/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";

import { AST } from '../engine/runtime-parser/ast.js';

import ListSelector from "./atoms/ListSelector";
import { Icon } from "./Icon";
import { formatDate } from "../engine/date-helpers";



//ret.isDate = res.expr.nodeType === AST.NODETYPE_DATE;
//ret.isIdent = res.expr.nodeType === AST.NODETYPE_IDENT;
//ret.isFunc = res.expr.nodeType === AST.NODETYPE_FUNCTION;

export default function DateEditor(props) {
  // Parse and eval the current expression
  const res = props.simModel.parseExpression(props.expr);
  const val = props.simModel.evaluateExpression(res.ast);

  const [showEditor, setShowEditor] = useState(false);


  function handleEnableEdit(event) {
    event.preventDefault();

    setShowEditor(!showEditor);
  }


  function handleCancel() {
    setShowEditor(false);
  }


  // This is the expression source from the expression editor
  function handleUpdateExpr(expr) {
    props.onChange(expr);

    setShowEditor(false);
  }


  function Header(props) {
    if (props.show === false) {
      return null;
    }
      
    return (
      <div>
        <span>{JSON.stringify(props.val)}</span><Icon.Edit onClick={handleEnableEdit}/>
      </div>
    );
  }


  return (
    <div>
      <Header show={!showEditor} val={val} />

      <ExpressionEditor simModel={props.simModel} show={showEditor} root={res} onCancel={handleCancel} onChange={handleUpdateExpr} />
    </div>
  );
}


function ExpressionEditor(props) {
  const [root, setRoot] = useState(props.root); 
  // Currently result of expression is assumed to be date, would need to deal with this 
  // when this becomes a general expression editor
  const [value, setValue] = useState(new Date()); 
  // Change editor type seperate from current expression type
  const [exprType, setExprType] = useState(props.root.ast.nodeType); 
  

  console.log('func');
  useEffect(() => {
    console.log('effect');
    let val = props.simModel.evaluateExpression(root.ast);

    setValue(val);
    setExprType(root.ast.nodeType);
  }, [root]);


  function handleShowDatePicker(event) {
    event.preventDefault();

    setExprType(AST.NODETYPE_DATE);
  }


  function handleShowMilestonePicker(event) {
    event.preventDefault();

    setExprType(AST.NODETYPE_IDENT);
  }


  /**
   * 
   * @param {ParseResult} res 
   */
  function handleUpdateExpr(root) {
    // This is the new expression from any underlying type specfic editor.
    // User can still cancel or Submit this expression to the model
    if (root.errors === false) {
      setRoot(root);
    }
  }


  function handleSubmit(event) {
    event.preventDefault();

    props.onChange(root.source);
  }


  function isDate() {
    return exprType === AST.NODETYPE_DATE;
  }

  function isMilestone() {
    return exprType === AST.NODETYPE_IDENT;
  }


  if (props.show === false) {
    return null;
  }


  let type_style = {
    display: "inline-block",
    width: "20%"
  }

  let val_style = {
    display: "inline-block",
    width: "50%",

    textAlign: "right",
  }

  let action_style = {
    display: "inline-block",
    width: "30%",

    textAlign: "right",
  }

  return (
    <div>
      <div>
        <span style={type_style}>
          <Icon.Calendar selected={isDate()} onClick={handleShowDatePicker} />
          <Icon.List selected={isMilestone()} onClick={handleShowMilestonePicker} />
        </span>
        <span style={val_style}>{value.toLocaleDateString()}</span>
        <span style={action_style}>
          <Icon.Save onClick={handleSubmit} />
          <Icon.Cancel onClick={props.onCancel} />
        </span>
      </div>

      { isDate() && <DatePicker simModel={props.simModel} expr={root.source} value={value} onChange={handleUpdateExpr}/>}
      { isMilestone() && <MilestonePicker simModel={props.simModel} expr={root.source} value={value} onChange={handleUpdateExpr}/>}
    </div>
  );

}

// 0-Jan .. 11-Dec
// 0-Sun .. 6-Sat
// const month = today.toLocaleString('default', { month: 'long' });
// const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function DatePicker(props) {
  const names = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const [expr, setExpr] = useState(props.expr);
  const [year, setYear] = useState(props.value.getFullYear());
  const [month, setMonth] = useState(props.value.getMonth());


  function handlePreviousMonth(event) {
    event.preventDefault();

    if (month === 0) {
      setMonth(11);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
  }

  function handleNextMonth(event) {
    event.preventDefault();

    if (month === 11) {
      setMonth(0);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
  }


  function handleDaySelected(day) {
    let date = new Date(year, month, day);
    let new_date = formatDate(date);

    const res = props.simModel.parseExpression(new_date);

    props.onChange(res);
  }


//eeeeee
  let yr_style = {
    background: "#dddddd", 
  }

  let lr_style = {
    display: "inline-block",
    width: "10%",

    background: "#cccccc",
    textAlign: "center",
  }

  let mn_style = {
    display: "inline-block",
    width: "80%",

    textAlign: "center",
  }


  return (
    <div>
      <div style={yr_style}>
        <span style={lr_style}><Icon.CaretLeft title="Previous month" onClick={handlePreviousMonth} /></span>
        <span style={mn_style}>{names[month]}&nbsp;&nbsp;{year}</span>
        <span style={lr_style}><Icon.CaretRight title="Next month" onClick={handleNextMonth} /></span>
      </div>
      <Month year={year} month={month} onDaySelected={handleDaySelected} />
    </div>
  );
}


function Month(props) {
  let first_day = new Date(props.year, props.month, 1);
  let last_day = new Date(props.year, props.month + 1, 0);

  let day = first_day.getDay();
  let num_days = last_day.getDate();

  let days = [];
  for (let i = 0; i < 42; i++) {
    days.push(0);
  }

  for (let i = 0; i < num_days; i++) {
    days[i + day] = i + 1;
  }

  let weeks = [];
  let week = [];
  let sum = 0;
  for (let d = 0; d < 42; d++) {
    week.push(days[d]);
    sum += days[d];

    if ((d + 1) % 7 === 0) {
      // Week 5 or 6 may not have any days in them
      if (sum > 0) {
        weeks.push(week);
        sum = 0;
        week = [];
      }
    }
  }

  // Week 5 or 6 may not have any days in them
  if (sum > 0) {
    weeks.push(week);
  }


  function handleDaySelect(event) {
    event.preventDefault();

    if (event.target === null) {
      return;
    }

    if (event.target.localName !== 'span') {
      return;
    }

    if (event.target.dataset === undefined) {
      return;
    }

    if (event.target.dataset.day === undefined) {
      return;
    }


    props.onDaySelected(event.target.dataset.day);
  }


  let mn_style = {
    background: "#bbbbbb",
  }

  let hd_style = { // similar to day_style
    display: "inline-block",
    width: "14.25%"
  }


  return (
    <div onClick={handleDaySelect}>

      <div style={mn_style}>
        <span style={hd_style}>S</span>
        <span style={hd_style}>M</span>
        <span style={hd_style}>T</span>
        <span style={hd_style}>W</span>
        <span style={hd_style}>T</span>
        <span style={hd_style}>F</span>
        <span style={hd_style}>S</span>
      </div>

      {weeks.map((w, i) => <Week key={i} week={w} />)}
    </div>
  );

}


function Week(props) {

  return (
    <div>
      {props.week.map((d, i) => <Day key={i} day={d} />)}
    </div>

  );
}


function Day(props) {

  let day_style = {
    display: "inline-block",
    width: "14.25%"
  }

  let day = props.day > 0 ? props.day : "";

  return (
    <span data-day={day} style={day_style}>{day}</span>
  );
}


function MilestonePicker(props) {

  let items = props.simModel.milestones.map( m => { return { value: m.name, desc: m.desc } });

  function handleSelected(value) {
    event.preventDefault();

    const res = props.simModel.parseExpression(value);

    props.onChange(res);
  }


  return (
    <div>
      <p>Blah</p>
      <ListSelector items={items} value={props.expr} onChange={handleSelected} />
    </div>
  );
}
